import { SentryConfig as SentryConfigInterface } from '@lopo-tech/lopo-config/interfaces'

export const SentryConfig: SentryConfigInterface = {
  dsn: 'https://4a3a53c89f684bb08c8e7689cd79de93@kammerjaeger.services.mvp-lab.de/12',
  project: 'web',
  org: 'lopo-tech',
  url: 'https://kammerjaeger.services.mvp-lab.de'
}
